/**
 * 表示一个用于存取服务使用的服务项。
 * @export
 * @class ServiceEntry
 */
export default class ServiceEntry {
    
    /**
     * 服务实例。
     * @private
     * @type {*}
     * @memberof ServiceEntry
     */
    private _service: any = null;

    /**
     * 服务类型。
     * @private
     * @type {Function}
     * @memberof ServiceEntry
     */
    private _serviceType: Function = () => {
        //
    }

    /**
     * 获取服务的类型。
     * @readonly
     * @type {Function}
     * @memberof ServiceEntry
     */
    public get serviceType(): Function {
        return this._serviceType;
    }

    /**
     * 创建服务实例。
     * @protected
     * @returns {*}
     * @memberof ServiceEntry
     */
    protected createService(): any {
        const ctor: any = this._serviceType;
        // eslint-disable-next-line new-cap
        return ctor ? new ctor() : null;
    }

    /**
     * 获取服务实例。
     * @readonly
     * @type {*}
     * @memberof ServiceEntry
     */
    public get service(): any {
        if (!this._service) {
            // 创建一个新的服务实例。
            this._service = this.createService();
        }

        return this._service;
    }

    /**
     * 初始化服务项的实例。
     * @memberof ServiceEntry
     */
    public constructor(serviceType: Function, service?: any) {
        if (!serviceType) {
            throw new Error("Can not create service entry, please check the arguments.");
        }

        if (service && service.constructor !== serviceType) {
            throw new Error("Service instance does not match service type.");
        }

        this._serviceType = serviceType;
        this._service = service || null;
    }

}
